/*
 * Module for viewing UI Configurations, which are named parameter settings
 * which can be used when connecting to the Engine's SOAP API
 */

define([
  "marionette",
  "messaging/messenger",
  "./uiConfigView",
  "modules/accountAdmin/kbProfile/uiConfigModal/uiConfigModalModule",
  "./uiConfigModel",
], function (Marionette, Messenger, UIConfigView, UIConfigModalModule) {
  var UIConfigController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "uiConfigModule";
      this.region = options.region;
      this.kb = options.model;
      this._setUpVents();
    },
    show: function () {
      Messenger.onSave(function () {
        console.log("saving ui config configuration");
        Messenger.saveAttempted(true);
      }, this);
      this.uiConfigs = Messenger.reqres.request("ui:configs");
      this.view = new UIConfigView.uiConfigView({ collection: this.uiConfigs });
      //attach the languages, touchpoints, contexts, and priv area roles
      //to the collection for all the models to use
      this._attachKbDetails();

      this.view.on(
        "add:config",
        function () {
          const newConfig = this.uiConfigs.addNewUIConfig();
          Messenger.vent.trigger("show:modal", UIConfigModalModule, {}, newConfig, {
            title: "admin.uiConfig.addConfig",
            closeButton: false,
            closeOnBackgroundClick: false,
            modalWidth: 550,
            trackInteraction: {
              action: "Add UI Configuration",
              object: "UI Configuration",
            },
          });
          //open a modal to create the new config
        },
        this,
      );

      this.view.on(
        "itemview:delete:config",
        function (itemView) {
          //show a confirmation message before deleting the config.  Really need to make sure they want to do it,
          //because deletion will break all UIs which use the configuration.
          Messenger.yesNoDialog(
            "admin.uiConfig.deleteConfig",
            {
              yes: function () {
                Messenger.vent.trigger("track:interaction", {
                  action: "Delete UI Configuration",
                  id: itemView.model.id,
                  idType: "UI Configuration",
                  object: "UI Configuration",
                });
                itemView.model.deleteModel();
              },
            },
            this,
          );
        },
        this,
      );

      this.view.on(
        "itemview:edit:config",
        function (itemView) {
          //open up a modal to edit the config
          Messenger.vent.trigger("show:modal", UIConfigModalModule, {}, itemView.model, {
            title: "admin.uiConfig.editConfig",
            closeButton: false,
            closeOnBackgroundClick: false,
            modalWidth: 550,
            trackInteraction: {
              action: "Edit UI Configuration",
              id: itemView.model.id,
              idType: "UI Configuration",
              object: "UI Configuration",
            },
          });
        },
        this,
      );
      this.showRegion(this.view);
    },
    _attachKbDetails: function () {
      this.uiConfigs.touchpoints = this.kb.getTouchPoints();
      this.uiConfigs.contexts = this.kb.getContexts();
      this.uiConfigs.languages = this.kb.getLocales();
      this.uiConfigs.roles = Messenger.reqres.request("kb:privileged:area:roles");
      //re-render when all lists are synced
      this.uiConfigs.touchpoints.onSynced(function () {
        this.uiConfigs.contexts.onSynced(function () {
          this.uiConfigs.languages.onSynced(function () {
            this.uiConfigs.roles.onSynced(function () {
              this.view.render();
            }, this);
          }, this);
        }, this);
      }, this);
    },
    _setUpVents: function () {
      //show the module
      Messenger.vent.on(
        "show:kb:admin:uiConfigs",
        function () {
          this.show();
        },
        this,
      );
      Messenger.vent.on(
        "show:kb:profile:uiConfigs",
        function () {
          this.show();
        },
        this,
      );
      Messenger.vent.on(
        "refresh:kb:response:settings",
        function (updatedKb) {
          this.kb = updatedKb;
        },
        this,
      );
    },
  });

  return UIConfigController;
});
